import http from '@/http-common'
import Tab from '../../components/TabSpr.vue'

export default {
    name: 'rank',
    components: {Tab},
    props: {
        isCalled: {
            type: Boolean,
            default: false,
        },
        columns: {
            type: Array,
            default: () => [
                {key: 'code', label: 'Код'},
                {key: 'name', label: 'Наименование', sortable: true, sorted: true},
                {key: 'shortName', label: 'Краткое наименование', sortable: true, sorted: true},
                {key: 'edit_field', label: '', firstClass: 'width10', sortable: false}
            ],
        }
    },
    data() {
        return {
            isBusy: false,
            captionTable: 'Справочник званий',
            selectedItem: {
                name: '',
                code: '',
            },
            captionSpr: {
                name: 'Звания',
                nameR: 'Звание'
            },
            items: [],
            urls: {
                save: '/rank/save',
                delete: '/rank/delete',
            },
            modalEditOpened: false,
            validValue: {
                name: true,
                form: true
            },
        }
    },
    created() {
        this.loadItems();
    },
    methods: {
        checkForm() {
            for (var key in this.validValue) {
                this.validValue[key] = true;
            }
            if (!this.selectedItem.name || this.selectedItem.name == '') {
                this.validValue.name = false;
                this.validValue.form = false;
            }
        },
        loadItems() {
            var vm = this;
            this.isBusy = true;
            http.get('/rank/list')
                .then((response) => {
                    vm.items = response.data;
                })
                .catch((error) => console.log(error.message))
                .finally(() => vm.isBusy = false);
        },
        rowSelected(items) {
            for (var key in items[0]) {
                this.selectedItem[key] = items[0][key];
            }
            this.$emit('input', this.selectedItem)
        },
        showEditDialog() {
            if (this.isCalled && this.selectedItem.id > 0) {
                this.rowSelected([this.selectedItem]);
                this.$emit('selectItem')
            } else {
                this.modalEditOpened = !this.modalEditOpened;
            }
        },
        saveItem() {
            this.checkForm();
            if (this.validValue.form) {
                this.modalEditOpened = false;
                this.$refs.RankTab.save(this.selectedItem);
            }
        }
    }
}
